import { useSelector } from "react-redux";
import {
  Duration_model,
  IELTS_SCORE_SELECT_MODEL,
} from "../../Models/CoursesModel";
import RangeSlider from "../../Components/RangeSilder";
import { useState } from "react";

export default function CourseFilter({
  handleFilter,
  TableFilter,
  handleClearFilter,
  handleSliderFilter,
}) {
  const [SliderValue, setSliderValue] = useState({ min: 100, max: 60000 });
  const { Country_List } = useSelector((state) => state.COUNTRY_LIST_REDUCER);
  const { UniversityList } = useSelector(
    (state) => state.UNIVERSITY_LIST_REDUCER
  );

  const { userRecs } = useSelector((s) => s.listUserReducer);
  const { Intake_List } = useSelector((state) => state.INTAKE_LIST_REDUCER);
  const { Course_Offered_List } = useSelector(
    (state) => state.COURSE_OFFERED_LIST_REDUCER
  );
  const { partnerRecs } = useSelector((s) => s.listPartnerReducer);
  const { total } = useSelector((state) => state.listContactReducer);

  const handleChange = (e) => {
    setSliderValue({ min: e[0], max: e[1] });
    handleSliderFilter(e);
  };

  const handleRest = (e) => {
    e.preventDefault();
    setSliderValue({ min: 100, max: 60000 });
    handleClearFilter();
  };

  return (
    <div className="add-filter">
      <div className="filter-title  filter-title-mob">
        <h5>Filter Contacts</h5>
        <button className="mob-nav-open">☰</button>
      </div>
      <div className="filter-body filter-body-mob custom-scroll-right pt-0">
        <div className="sticky pt-2">
          <h6>
            <strong>Contacts Record</strong>
          </h6>
          <p style={{ marginTop: "5px" }}>
            showing {total ? total : 0} Courses
          </p>
        </div>
        <div className="sticky pt-2">
          <h6>
            <strong> All Filter</strong>
          </h6>
          <button
            onClick={(e) => handleRest(e)}
            className="btn btn-sm btn-deep-orange"
          >
            Clear All
          </button>
          <div>
            <ul className="modify-filter-title">
              {/* Country Filter  */}
              <li className="chose">Primary Contact</li>
              <li>
                <select
                  className="form-control"
                  name="userid"
                  value={TableFilter.userid}
                  onChange={handleFilter}
                >
                  <option value="">--Select--</option>
                  {userRecs?.map((el) => (
                    <option key={el.Users_Id} value={el.Users_Id}>
                      {el.Name}
                    </option>
                  ))}
                </select>
              </li>
              {/* University Filter  */}
              <li className="chose">Affiliate Partners</li>
              <li>
                <select
                  className="form-control"
                  name="AffiliatePartner"
                  value={TableFilter.AffiliatePartner}
                  onChange={handleFilter}
                >
                  <option value="">--Select--</option>
                  {partnerRecs?.map((el) => (
                    <option
                      key={el.Affiliate_Partner_Id}
                      value={el.Affiliate_Partner_Id}
                    >
                      {el.Affiliate_Partner}
                    </option>
                  ))}
                </select>
              </li>
              {/* Study Level Filter  */}
              {/* <li className="chose">Partner Date From</li>
              <li>
                <select
                  className="form-control"
                  name="StudyLevel"
                  value={TableFilter.StudyLevel}
                  onChange={handleFilter}
                >
                  <option value="">--Select--</option>
                  {Course_Offered_List?.map((el) => (
                    <option key={el.Id} value={el.Id}>
                      {el.Study_Level}
                    </option>
                  ))}
                </select>
              </li> */}

              {/* Intake Filter  */}
              {/* <li className="chose">Intake</li>
              <li>
                <select
                  className="form-control"
                  name="Intake"
                  value={TableFilter.Intake}
                  onChange={handleFilter}
                >
                  <option value="">--Select--</option>
                  {Intake_List?.map((el) => (
                    <option key={el.Id} value={el.Id}>
                      {el.Intake}
                    </option>
                  ))}
                </select>
              </li> */}
              {/* Duration Filter  */}
            </ul>
          </div>
        </div>
      </div>
    </div>
  );
}
